<div class="contenedor-galeria">
    <div class="columna" *ngFor="let columna of columnas">
      <div class="item" *ngFor="let altura of columna" [ngStyle]="{ 'height': altura + 'px' }">
        <span class="numero">{{ altura }}</span>
      </div>
    </div>
  </div>
  